import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from '@mui/icons-material/Close';
import TextInput from "../common/textInput/TextInput";
import Adornment from "../common/textInput/Adornment";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import ButtonLayout from "../common/button/ButtonLayout";
import { useState, useEffect } from "react";
import DialogView from "../common/dialogView/DialogView";
import DataTable from "../common/dataTable/DataTable";
import { useMediaQuery, useTheme } from "@mui/material";
import DataList from "../common/dataList/DataList";
import { createQuantityPart } from '../../services/partServices';
import SimpleBackdrop from '../common/backdrop/Backdrop';
import SimpleSnackbar from '../common/snackbar/Snackbar';
import { getPartsList } from '../../services/partServices';
import { SOURCE, UPDATE_PARTS, ADD_PARTS, COLOR_RED, MT_4PX, PART_REQ_FIELD, PART_ALREADY_ADDED_MSG, QTY_REQ_MSG, QTY_VALIDATION_MSG } from "../../utils/constants/GlobalConstants";
const AddNewParts = (props) => {
  const [open, setOpen] = useState(false);
  const [enableBtn, setEnableBtn] = useState(false);
  const [selected, setSelected] = useState({ index: null, record: null });
  const [selectedPart, setSelectedPart] = useState('');
  const [partsRows, setPartsRows] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [apiError, setApiError] = useState({ val: false, messages: "" });
  const [quantity, setQuantity] = useState('');
  // const [allowQuantity, setAllowQuantity] = useState(null);
  const [showError, setShowError] = useState(false);
  const [searchedData, setSearchedData] = useState();
  const [existingPart, setExistingPart] = useState(false);
  const [invalidQuantity, setInvalidQuantity] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    if (props.selectedDetails?.parts && props.header === UPDATE_PARTS) {
      setSelectedPart(props.selectedDetails?.parts);
      setQuantity(props.selectedDetails?.quantity);
      setShowCloseIcon(true);
    }
  }, [props.selectedDetails, props.header]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleChecked = (e, record, index) => {
    if (selected && selected.index === index) {
      setEnableBtn(false);
      setSelected({ index: null, record: null });
    }
    else {
      setEnableBtn(true);
      setSelected({ index, record });
    }

  }
  const numericRegex = /^\d{0,2}$/;
  const handleAction = (e) => {
    if (e === 'select') {
      setSelectedPart(selected?.record?.partNumber);
      setShowCloseIcon(true);
    } else if (e === 'remove') {
      setSelectedPart('');
      setSelected('');
    }
    handleClose();

  }
  const handleSearch = (val) => {
    setSearchedData(val);
  }
  const partsList = async () => {
    setLoader(true)
    try {
      const response = await getPartsList();
      const reverseParts = response?.parts?.reverse();
      setPartsRows(reverseParts);
      const index = reverseParts.findIndex(rec => rec.partNumber === selectedPart);
      const record = { checkbox: "", partNumber: selectedPart };
      setSelected({ index, record });
      setLoader(false)
    } catch (error) {
      setApiError((val) => ({ ...val, val: true, message: error.message }));
      setLoader(false)
    }
  }
  const handleInputChange = (e) => {
    setQuantity(e.target.value);
  }

  // const getQuantity = (qty) => {
  //   const selectedPart = props.selectedDetails;
  //   const updatedItem = props.partRows?.map(item =>
  //     item.partNumber === selectedPart.parts ? { ...item, quantity: qty } : item
  //   );
  //   const totalQty = updatedItem?.reduce((sum, item) => sum + parseInt(item.quantity), 0);
  //   return totalQty;
  // }

  const handleSubmit = async () => {
    const validQuantity = numericRegex.test(quantity);
    setInvalidQuantity(!validQuantity);
    //const allowableQty = numericRegex.test(quantity) ? (props.header === ADD_PARTS) ? (props.totalQuantity + parseInt(quantity ? quantity : 0)) : (getQuantity(parseInt(quantity ? quantity : 0))) : null;
    const dataExist = props.partRows?.some(item => item.partNumber === selectedPart);
    setExistingPart(dataExist);
    // allowableQty && setAllowQuantity(allowableQty);
    const debiId = props.id?.craetedebiFlag ? props.id?.dataToDetails?.id : props.id;
    if (selectedPart 
      // && allowableQty && allowableQty <= 18 
      && debiId 
      && validQuantity
      ) {

      if ((props.header === ADD_PARTS) && !dataExist) {
        setShowError(false);
        setLoader(true)
        try {
          const req = {
            debiId: debiId,
            partNumber: selectedPart,
            quantity: quantity
          }
          const response = await createQuantityPart(req);
          setLoader(false);
          if (response?.id) {
            req.id = response.id;
            props.partModied(req, ADD_PARTS, '');
            props.setOpenPart(false);
            props.updatedPartList();
          } else {
            console.log('add part failed');
          }
        }
        catch (error) {
          setApiError((val) => ({ ...val, val: true, message: error.message }));
          setLoader(false)
        }
      } else if ((props.header === UPDATE_PARTS)) {
        setShowError(false);
        setLoader(true);
        let data = props.partRows.find(item => item.partNumber === props.selectedDetails?.parts);
        const index = props.partRows.findIndex(rec => rec.partNumber === props.selectedDetails?.parts);
        let details;
        if (props.selectedDetails?.parts !== selectedPart) {
          details = partsRows.find(item => item.partNumber === selectedPart);
        }
        const partSelected = props.selectedDetails?.parts === selectedPart ? data.partNumber : details.partNumber;
        try {
          const req = {
            id: data.id,
            debiId: debiId,
            partNumber: partSelected,
            quantity: quantity
          }
          const response = await createQuantityPart(req)
          setLoader(false);
          if (response?.id) {
            const send = {
              id: data.id,
              debiId: debiId,
              partNumber: selectedPart,
              quantity: quantity
            }
            props.partModied(send, UPDATE_PARTS, index);
            props.setOpenPart(false);
            props.updatedPartList();
          } else {
            console.log('update part failed');
          }
        }
        catch (error) {
          setApiError((val) => ({ ...val, val: true, message: error.message }));
          setLoader(false)
        }
      } else {
        setShowError(true);
      }
    } else {
      setShowError(true);
    }
  }
  return (
    <><SimpleBackdrop open={loader} />
      <DialogView
        open={open}
        handleClose={() => handleClose()}
        width={isMobile ? "75%" : "53%"}
        maxWidth={"75em!important"}
        heading={ADD_PARTS}
        testid={"dialog-partinside"}
        enableBtn={enableBtn}
        handleAction={handleAction}
        handleSearch={handleSearch}
        childComponet={isMobile ?
          <DataList searchedData={searchedData} rows={partsRows} source={SOURCE.PARTSINSIDE} handleChecked={handleChecked} selected={selected} /> :
          <DataTable testid="datatable" searchedData={searchedData} rows={partsRows} source={SOURCE.PARTSINSIDE} handleChecked={handleChecked} selected={selected} />}
      />
      <GridContainer spacing={2}>
        <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
          <TextInput
            sx={{ width: "70%" }}
            label="Part"
            required={true}
            value={selectedPart}
            InputProps={{
              endAdornment: (
                <Adornment>
                  {(selectedPart && showCloseIcon) ?
                    (
                      <CloseIcon
                        testid="close-icon"
                        disabled
                        sx={{
                          marginRight: "10px",
                        }}
                        onClick={() => {
                          setSelectedPart("");
                          setShowCloseIcon(false);
                          setSelected("")

                        }} />) : null}
                  <SearchIcon
                    testid="search-icon"
                    onClick={() => {
                      partsList();
                      setEnableBtn(selectedPart ? true : false);
                      setOpen(true);
                    }}
                  />
                </Adornment>
              ),
            }}
          />
          {showError && !selectedPart && (
            <div style={{ ...COLOR_RED, ...MT_4PX }} testid="part-error">
              {PART_REQ_FIELD}
            </div>
          )}
          {showError && selectedPart && existingPart && props.header !== UPDATE_PARTS && (
            <div style={{ ...COLOR_RED, ...MT_4PX }}>
              {PART_ALREADY_ADDED_MSG}
            </div>
          )}
        </GridItem>
        <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
          <TextInput type={'number'} inputProps={{ maxLength: 2 }} testid="input" sx={{ width: "70%" }} label={"Quantity"} onChange={handleInputChange} value={quantity} required={true} />
          {showError && !quantity && (
            <div style={{ ...COLOR_RED, ...MT_4PX }} testid="qty-div">
              {QTY_REQ_MSG}
            </div>
          )}
          {/* {showError && allowQuantity && allowQuantity > 18 && (
            <div style={{ ...COLOR_RED, ...MT_4PX }}>
              {TOT_QTY_EXCEED_MSG}
            </div> */}
          {/* )} */}
          {showError && quantity && invalidQuantity && (
            <div style={{ ...COLOR_RED, ...MT_4PX }}>
              

              {QTY_VALIDATION_MSG}
            </div>
          )}
        </GridItem>
        <GridItem xs={12} sm={12} lg={12} md={12} xl={12}>
          <br /> <br />
          <div className="flex-container flex-right">
            <ButtonLayout label="Submit" onClickBtn={handleSubmit} testid="submit-btn" />
          </div>
        </GridItem>
      </GridContainer>
      <SimpleSnackbar apiError={apiError} />
    </>
  );
};
export default AddNewParts;
